function clamp(value: number, min: number, max: number) {
  return Math.max(min, Math.min(value, max));
}

function distance(x1: number, y1: number, x2: number, y2: number) {
  const a = x1 - x2;
  const b = y1 - y2;

  return Math.sqrt((a * a) + (b * b));
}

function midpoint(x1: number, y1: number, x2: number, y2: number) {
  return {
    x: (x1 + x2) * 0.5,
    y: (y1 + y2) * 0.5,
  };
}

function toFixedNumber(value: number, digits: number, base = 10) {
  const power = base ** digits;

  return Math.round(value * power) / power;
}

export {
  clamp,
  distance,
  midpoint,
  toFixedNumber,
};
